/* eslint-disable import/no-anonymous-default-export */
export default {
  appUrl: process.env.REACT_APP_BACKEND_URL || "https://mashy-api.onrender.com/"
  // appUrl: process.env.REACT_APP_LOCAL_URL || "http://localhost:5000/"
};
